import React, { useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { selectToken } from "../../store/user/selectors";

import { logOut } from "../../store/user/actions";

// import LoggedIn from "./LoggedIn";
// import LoggedOut from "./LoggedOut";
// import NavbarItem from "./NavbarItem";
import Logo from "../../images/TheBestDish.png";

import "./style.css";
import LogInModal from "./LogInModal";

export default function Navigation() {
  const token = useSelector(selectToken);
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);

  // const loginLogoutControls = token ? <LoggedIn /> : <LoggedOut />;
  console.log(token);
  return (
    // <div>
    //   <NavbarItem path="/" linkText="Home" />
    //   {loginLogoutControls}
    // </div>

    <nav className="nav">
      {modalOpen && (
        <LogInModal open={modalOpen} closeModal={() => setModalOpen(false)} />
      )}
      <img class="logo" alt="logo" src={Logo}></img>

      <ul className="nav-list">
        <a href="/">
          <li>Home</li>
        </a>

        {!token ? (
          <button className="nav-button" onClick={() => setModalOpen(true)}>
            <li>Login</li>
          </button>
        ) : (
          <button className="nav-button" onClick={() => dispatch(logOut())}>
            <li>Logout</li>
          </button>
        )}

        {/* <a>{loginLogoutControls}</a> */}
      </ul>
    </nav>
  );
}
